import React, { useState } from "react";
import { Tables } from "../../../../components/Elements/Tables/Tables";
import { ReactComponent as RightArrow } from "../../../../assets/svgs/rightArrow.svg";
import { ReactComponent as BackIcon } from "../../../../assets/svgs/back-square.svg";
import { SearchBar } from "../../../../components/Elements/Search/SearchBar";
import { EyeOutlined, EditOutlined } from "@ant-design/icons";
import { ReactComponent as EditIcon } from "../../../../assets/svgs/edit-icon.svg";
import { ReactComponent as EyeIcon } from "../../../../assets/svgs/eye-icon.svg";
import CustomSwitch from "../../../../components/Elements/CustomSwitch/CustomSwitch";
import { Button } from "antd";
import SortData from "../../../../components/Elements/SortData.js/SortData";
import { useNavigate } from "react-router-dom";
import AddNewDivisions from "./AddNew/AddNewDivisions";
import TextStyles from "../../../../components/Elements/TextStyles/TextStyles";

const divisionSample = [
  {
    key: 1,
    tableData: [
      {
        serial: "1",
        division: "BRSR",
        status: "Active",
      },
    ],
  },
  {
    key: 2,
    tableData: [
      {
        serial: "2",
        division: "Scope 1-2",
        status: "InActive",
      },
    ],
  },
  {
    key: 3,
    tableData: [
      {
        serial: "3",
        division: "Scope 3",
        status: "Draft",
      },
    ],
  },
  {
    key: 4,
    tableData: [
      {
        serial: "4",
        division: "SINGLE ENTITY",
        status: "Active",
      },
    ],
  },
  {
    key: 5,
    tableData: [
      {
        serial: "5",
        division: "OG ESGREPORTING",
        status: "Inactive",
      },
    ],
  },
  {
    key: 6,
    tableData: [
      {
        serial: "6",
        division: "BRSR",
        status: "Draft",
      },
    ],
  },
  {
    key: 7,
    tableData: [
      {
        serial: "7",
        division: "Scope 1-2",
        status: "Active",
      },
    ],
  },
];

const Divisions = () => {
  const [OpenAddNew, setOpenAddnew] = useState(false);
  const navigate = useNavigate();

  const tableData = divisionSample.map((item) => {
    const { serial, division, status } = item.tableData[0];
    return {
      key: item.key,
      serial,
      division,
      status: (
        <div className="text-xs w-36 rounded-md py-2 text-center items-center bg-green-100 text-blue-800 font-semibold">
          {status}
        </div>
      ),
      action: (
        <div className="flex gap-4 items-center">
          <EyeIcon
            className=""
            style={{ fontSize: "18px", cursor: "pointer" }}
            onClick={() => {
              navigate(
                "/organization/my-question-bank/sub-section/divisions/questions",
              );
            }}
          />
          <EditIcon
            style={{ fontSize: "18px", cursor: "pointer" }}
            onClick={() => {
              setOpenAddnew(true);
            }}
          />
          <CustomSwitch
            checked={true}
            onChange={(checked) =>
              console.log(`Custom switch toggled, Status: ${checked}`)
            }
          />
        </div>
      ),
    };
  });

  const [filteredData, setFilteredData] = useState(tableData);
  const [sortBy, setSortBy] = useState(null);
  const [sortOrder, setSortOrder] = useState(null);

  const headers = [
    { label: "Sr. No.", key: "serial" },
    { label: "Divisions", key: "division" },
    { label: "Status", key: "status" },
    { label: "Action", key: "action" },
  ];

  const handleSearch = (searchTerm) => {
    const lowercasedTerm = searchTerm.toLowerCase();
    const filtered = tableData.filter((item) =>
      headers.some(
        (header) =>
          header.key !== "action" &&
          String(item[header.key]).toLowerCase().includes(lowercasedTerm),
      ),
    );
    setFilteredData(filtered);
  };

  const handleOpenAddNew = () => {
    setOpenAddnew(true);
  };

  const handleSort = (key, order) => {
    const sortedData = SortData({ data: filteredData, key, order });
    setFilteredData(sortedData);
    setSortBy(key);
    setSortOrder(order);
  };

  const handleBack = () => {
    navigate("/organization/my-question-bank/sub-section");
  };

  return (
    <div
      style={{ padding: "40px", backgroundColor: "#fff" }}
      className="h-screen"
    >
      <div className="flex justify-end text-xs font-light p-3">
        <p>Home</p>
        <span>/</span>
        <p>Dynamic Form</p>
        <span>/</span>
        <p>Form Sections</p>
        <span>/</span>
        <p>Sub Sections</p>
        <span>/</span>
        <TextStyles color="gradient">Divisions</TextStyles>
      </div>
      <div className="flex items-center  gap-2 text-xl  font-bold">
        <BackIcon onClick={handleBack} />
        <TextStyles color="gradient" style={{ marginTop: "18px" }}>
          Divisions (Demo 155)
        </TextStyles>
      </div>
      <div
        style={{
          border: "1px solid #3BA2B959",
          borderRadius: "10px",
          paddingTop: "20px",
          boxShadow: "0px 0px 16px 0px #3BA2B91F",
        }}
        className="pt-2 px-2"
      >
        <div className="flex justify-between mx-8 py-4">
          <div className=" flex items-center gap-5 ">
            <div
              style={{
                background: "#B6D4D933",
                height: "40px",
              }}
              className=" border border-gray-300 rounded-md text-gray-400 text-base font-light"
            >
              <p
                style={{
                  fontFamily: "Calibri",
                  fontWeight: "300",
                  fontSize: "16px",
                  lineHeight: "24px",
                  letterSpacing: "0%",
                }}
                className="pt-2 px-2"
              >
                TOTAL SECTION 10
              </p>
            </div>
            <SearchBar onSearch={handleSearch} width="300px" />
          </div>
          <Button
            type="primary"
            style={{ background: "#0087A3" }}
            className="text-sm font-light w-40 py-5"
            onClick={handleOpenAddNew}
          >
            + Add New
          </Button>
        </div>
        <div className="p-4">
          <hr className="p-4" />
        </div>
        <Tables
          data={filteredData}
          headers={headers}
          pageSize={4}
          onSort={handleSort}
          sortBy={sortBy}
          sortOrder={sortOrder}
        />
        {OpenAddNew && (
          <AddNewDivisions
            onOpen={OpenAddNew}
            onClose={() => {
              setOpenAddnew(false);
            }}
          />
        )}
      </div>
    </div>
  );
};

export default Divisions;
